<template>
  <div class="dataBox">
    <!-- <div class="tools">
      <div class="tools-left">
        <div class="number">已选择 {{ selectList.length }} 条记录</div>
        <el-button
          :disabled="!selectSubmitList.length"
          size="mini"
          type="danger"
          class="btn submitBtn"
          @click="onBatchSign"
          >批量签署</el-button
        >
      </div>
      <div class="tools-right"></div>
    </div> -->

    <el-table
      :data="signContractTipData"
      style="width: 100%; margin-bottom: 10px"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
      @selection-change="handleSelectionChange"
    >
      <template slot="empty">
        <img
          class="data-pic"
          src="../../../../../assets/images/H5/null.png"
          alt
        />
        <br />暂无数据
      </template>
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <span>{{
            scope.row && scope.row.contractUser && scope.row.contractUser.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creditAssignee" label="委托方"></el-table-column>
      <!-- <el-table-column prop="name" label="签署批次">
        <template slot-scope="scope">
          <span>{{ scope.row.batchNo ? scope.row.batchNo : '-' }}</span>
          <span v-if="scope.row.batchSigning" class="red">（批量签署中）</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="signStartTime" label="发起日期"></el-table-column>
      <el-table-column label="合同状态">
        <template slot-scope="scope">{{
          computedStatus(scope.row && scope.row.signStatus)
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
            <div
              class="cursorPointer goSign"
              @click="toSignTrue(scope.row)"
              v-if="judgeArrHandler(scope.row, 'SIGN', '1')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">去签署</span>
            </div>
            <div
              class="cursorPointer reject"
              v-if="judgeShowReject(scope.row)"
              @click="toReject(scope.row, '1')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">拒签</span>
            </div>
            <div
              class="cursorPointer continueSign"
              @click="stopContract(scope.row, false)"
              v-if="judgeArrHandler(scope.row, 'CONFIRM')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">继续签</span>
            </div>
            <div
              class="cursorPointer goSign"
              v-if="scope.row.signStatus == 0"
              @click="toRestSin(scope.row, '1')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">重新发起</span>
            </div>
            <div
              class="cursorPointer revoke"
              v-if="judgeShowRevoke(scope.row)"
              @click="revoke(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">撤销</span>
            </div>
            <div
              class="cursorPointer delete"
              v-if="scope.row.signStatus == 0"
              @click="deleteSign(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">删除</span>
            </div>

            <div
              class="cursorPointer tip"
              @click="tipPerson(scope.row)"
              v-if="judgeTip(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">提醒</span>
            </div>
            <div
              class="cursorPointer"
              v-if="
                judgeLoad(scope.row) &&
                scope.row.signStatus == 2 &&
                ((scope.row.type == 2 &&
                  getUserInfo.currentUserId != scope.row.contractUser.userId) ||
                  (scope.row.type == 4 && scope.row.signatoryRoleCode == 'DR'))
              "
            >
              <el-popover
                popper-class="CompleteSign_popper"
                placement="bottom"
                width="154"
                trigger="hover"
              >
                <!-- <div class="notratType" v-if="scope.row.type==1 || scope.row.type==2 && getUserInfo.currentUserId == scope.row.contractUser.userId">
                      <p @click="addNotrat(scope.row)">普通公证</p>
                    </div> -->
                <div
                  class="notratType"
                  v-if="
                    scope.row.type == 2 &&
                    getUserInfo.currentUserId != scope.row.contractUser.userId
                  "
                >
                  <!-- <p @click="addNotrat(scope.row)">普通公证</p> -->
                  <p @click="addNotrats(scope.row)">贷款赋强公证</p>
                </div>
                <div
                  class="notratType"
                  v-if="
                    scope.row.type == 4 && scope.row.signatoryRoleCode == 'DR'
                  "
                >
                  <!-- <p @click="addNotrat(scope.row)">普通公证</p> -->
                  <p @click="addNotrats(scope.row)">调解赋强公证</p>
                </div>
                <span class="iconDscp" slot="reference">申请公证</span>
              </el-popover>
              <!-- <span class="icon"></span> -->
            </div>
            <div
              class="cursorPointer"
              @click="toLoad(scope.row)"
              v-if="judgeLoad(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">下载</span>
            </div>
            <div
              class="cursorPointer"
              @click="stopContract(scope.row, true)"
              v-if="judgeArrHandler(scope.row, 'CONFIRM')"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">终止</span>
            </div>

            <div
              class="cursorPointer tip"
              @click="onReSign(scope.row)"
              v-if="scope.row.canReSign"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">重新签</span>
            </div>

            <div
              class="cursorPointer"
              v-if="scope.row.signStatus != 0"
              @click="toDetail(scope.row)"
            >
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">详情</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Dialog
      :visible="applyNotar"
      :dialogTitle="'申请公证'"
      v-on:closeDialog="closeDialog"
      :width="'600px'"
    >
      <div slot="dialog">
        <div class="applyNotar">
          <apply
            @closeDialog="closeDialog"
            ref="multiples"
            :curRow="curRow"
            @applyNotar="applyNotarFn"
          ></apply>
        </div>
      </div>
    </Dialog>
    <Dialog
      :visible="applyNotars"
      :dialogTitle="'赋强公证'"
      v-on:closeDialog="closeDialogs"
      :width="'500px'"
    >
      <div slot="dialog">
        <div class="applyNotars">
          <div class="rlsbs wxapp-con">
            <p class="rlsb_desc">微信扫码在小程序完成赋强公证</p>
            <p class="rlsb_title">&nbsp;− 二维码5分钟内有效 −&nbsp;</p>
            <div class="erweima wxappCode">
              <!-- <vue-qr id="canvass" :text="codrUrl" :size="200"></vue-qr> -->
              <img :src="codrUrl" />
            </div>
            <div
              class="erweima_errro wxapperror"
              v-show="error_erweima && status == 1"
            >
              <p class="error_title">二维码失效</p>
              <span class="update_erweima" @click="updateEr">点击刷新</span>
            </div>
            <div class="erweima_success wxappsuccess" v-show="status == 0">
              <img
                src="../../../../../assets/images/userHome/wxsmcg_icon.png"
              />
              <p class="success_title">扫描成功</p>
              <p class="success_desc">请在手机端完成申请公证</p>
              <!-- <span class="success_update_erweima" @click="updateEr">点击刷新</span> -->
            </div>
            <!-- <div class="erweima_success" v-show="codeStatus==0">
                <img src="../../../../../assets/images/userHome/wxsmcg_iconS.png"/>
                <p class="success_title">已完成申请公证</p>
              </div> -->

            <!-- <button class="success_face" type="button" v-show="status==1||status==2"  @click="getFaceResult">已完成申请公证</button> -->
            <!-- <button class="error_face" type="button">未完成人脸验证</button> -->
          </div>
        </div>
      </div>
    </Dialog>
    <!-- <Dialog
      :visible="showmsg"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      :showClose="false"
      @closeDialog="closeDialog('authDialogShow')"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>{{errorMsg}}</p>
        </div>
        <div class="authHandlerBox" style="justify-content: center;">
          <div class="button cursorPointer" @click="closeDialog('authDialogShow')">取消</div>
          <div class="button buttonActive cursorPointer" @click="goAuth">去认证</div>
        </div>
      </div>
    </Dialog> -->
  </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import apply from "../../../service/components/applyNotar.vue";
import BaseApi from "@lib/baseApi.js";
import vueQr from "vue-qr";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      signContractTipData: [],
      applyNotar: false,
      applyNotars: false,
      codrUrl: "",
      status: 1, //二维码状态
      codeStatus: null, //认证状态
      error_num: false,
      //二维码扫描成功
      success_erweima: false,
      //二维码失效
      error_erweima: false,
      text: "",
      showmsg: false,
      isshowTimeEnd: false, //是否过期

      selectList: [], //  已选
      selectSubmitList: [], // 可提交
    };
  },
  components: {
    Dialog,
    apply,
    vueQr,
  },
  mounted() {},
  computed: {
    ...mapGetters(["getUserInfo", "getCurInfo"]),
  },
  methods: {
    setData(data) {
      this.signContractTipData = data;
    },
    computedStatus(signStatus) {
      let signStatusKey = ["未发起", "签署中", "签署完成", "终止", "拒签", "已出证"];
      return signStatusKey[signStatus];
    },
    judgeTip(row) {
      return row.remind;
    },
    getTaskId(data, flag, all) {
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            if (all) {
              return data[i];
            } else {
              return data[i].taskId;
            }
          }
        }
      }
      return false;
    },
    judgeLoad(row) {
      if (row.signStatus == 2) {
        return true;
      } else {
        return false;
      }
    },
    judgeShowReject(row) {
      let SignTask = this.getTaskId(row, "SIGN", true);
      if (SignTask) {
        if (row.contractUser.userId == SignTask.userId) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    judgeShowRevoke(row) {
      return this.getTaskId(row.taskList, "REVOKE");
    },
    revoke(row) {
      this.$emit("revokeContract", row);
    },
    toReject(row, flag) {
      this.$emit("toReject", row);
    },
    toSignTrue(row, flag) {
      this.$emit("toSignTrue", { data: row, flag: flag });
    },
    onReSign(row) {
      this.$emit("toReSign", { data: row });
    },
    stopContract(row, flag) {
      this.$emit("stopContract", { data: row, flag: flag });
    },
    tipPerson(row) {
      this.$emit("tipPerson", row);
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },
    toLoad(row) {
      this.$emit("toLoad", row);
    },

    toRestSin(row, flag) {
      if (row.type == 2) {
        //发起赋强合同
        this.$router.push(`/personal/sign/signLoanContract?id=${row.id}`);
      } else {
        //发起普通合同
        this.$router.push(
          `/personal/sign/index?id=${row.id}&type=1&from=draft`
        );
      }
    },
    deleteSign(row) {
      this.$emit("deleteSign", row);
    },

    judgeArrHandler(row, contractArrFlag, signArrFlag) {
      if (row.taskList && row.taskList.length) {
        for (let i = 0; i < row.taskList.length; i++) {
          if (row.taskList[i].actionCode == contractArrFlag) {
            if (!signArrFlag) {
              return true;
            } else {
              if (row.signStatus == signArrFlag) {
                return true;
              } else {
                return false;
              }
            }
            break;
          }
          if (i == row.taskList.length) {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    closeDialog() {
      this.applyNotar = false;
    },
    closeDialogs() {
      this.applyNotars = false;
    },
    //普通公证
    addNotrat(data) {
      this.curRow = data;
      this.applyNotar = true;
    },
    getUserInfos() {
      return BaseApi.createRpcToken("/user/v2/getUserInfo");
    },
    //实时获取二维码状态
    setTimerEr(contractId) {
      var timer = null;
      BaseApi.createRpcToken(
        "/notaryApply/getWxUrlStatus",
        { contractId },
        "GET"
      )
        .then(
          (data) => {
            if (data.code == 200) {
              clearTimeout(timer);
              this.status = data.datas.status;
              let self = this;
              if (self && !self._isDestroyed) {
                timer = setTimeout(() => {
                  this.setTimerEr(contractId);
                }, 1000);
              }
              if (this.isshowTimeEnd && data.datas.status != 0) {
                clearTimeout(timer);
              }
              //二维码失效
              else if (this.error_erweima) {
                clearTimeout(timer);
              } else if (data.datas.status == 0) {
                //扫码完成
                clearTimeout(timer);
              }
            } else {
              clearTimeout(timer); //清理定时任务
            }
          },
          (data) => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    //刷新二维码
    updateEr() {
      if (this.codeStatus == 0) {
        return;
      } else {
        this.error_erweima = false;
        this.addNotrats(this.infoData);
      }
    },
    //赋强公证
    addNotrats(info) {
      this.infoData = info;
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken(
        "/notaryApply/checkCanFqNotaryApply",
        {
          contractId: info.id,
          notaryId: 1,
        },
        "post"
      )
        .then((data) => {
          this.$store.commit("showLoading", false);
          let timer = null;
          var endTime = new Date().getTime() + 5 * 60 * 1000;
          timer = setInterval(() => {
            var start = new Date().getTime();
            if (start > endTime) {
              this.isshowTimeEnd = true;
              this.error_erweima = true;
              clearInterval(timer);
            } else {
              if (this.status == 0) {
                clearInterval(timer);
                this.isshowTimeEnd = false;
                this.error_erweima = false;
              } else {
                this.error_erweima = false;
              }
            }
          }, 1000);
          if (data.datas.code == 200) {
            // let bytes = new Uint8Array(window.btoa(datat));
            // let datat = "";
            // console.log(bytes)
            // let len = bytes.byteLength;
            // for (let i = 0; i < len; i++) {
            //   datat += String.fromCharCode(bytes[i]);
            // }
            // console.log(datat)
            // console.log(window.btoa(datat))
            this.codrUrl = "data:image/png;base64," + data.datas.wxUrlbase64;
            this.applyNotars = true;
            this.setTimerEr(info.id);
          } else {
            this.$message.error(data.datas.message);
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
    getFaceResult() {},
    applyNotarFn(data) {},

    // 选择
    handleSelectionChange(val) {
      let list = [];
      if (val.length) {
        val.forEach((item) => {
          if (this.judgeArrHandler(item, "SIGN", "1")) {
            list.push({
              id: item.id,
              name: item.name,
              code: item.code,
              userId: item.userId,
              debtorName: item.debtorName,
              taskId: this.getTaskId(item.taskList, "SIGN"),
              currUserSealParam: item.currUserSealParam ? JSON.parse(item.currUserSealParam) : null
            });
          }
        });
      }
      this.selectList = val;
      this.selectSubmitList = list;
      // sessionStorage.setItem('SignMediateBatch', JSON.stringify(list))
    },

    // 批量签署按钮
    onBatchSign() {
      this.$emit("onBatchSign", this.selectSubmitList);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.wxapp-con {
  height: 344px !important;
}
.wxappCode {
  width: 180px !important;
  height: 180px !important;
  margin-top: 40px !important;
}
.wxapperror {
  width: 180px !important;
  height: 180px !important;
  background: rgba(255, 255, 255, 0.78);
  position: absolute;
  top: 100px !important;
  left: 50%;
  margin-left: -90px !important;
  z-index: 99;
  text-align: center;
  padding-top: 60px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.wxappsuccess {
  width: 180px !important;
  height: 180px !important;
  background: rgba(255, 255, 255, 0.78);
  position: absolute;
  top: 97px !important;
  left: 50%;
  margin-left: -90px !important;
  z-index: 99;
  text-align: center;
  padding-top: 35px;
  box-sizing: border-box;
}
</style>


